module.exports = __webpack_public_path__ + "media/images/icon_ng-644ffbe53b1565a855824ec7a799609c.svg";